import { CircularProgress, Stack } from '@mui/material';
import { StyledLoginButton } from './style';
import { createGradientOrSolid } from 'utils';
import { Gradient } from 'utils/types';

interface LoginButtonProps {
  callback?: () => void;
  text?: string;
  iconClass?: string;
  iconSrc?: string;
  iconSize?: string;
  type?: string;
  variant?: string;
  children?: JSX.Element | JSX.Element[];
  textColor?: Gradient;
  backgroundColor?: Gradient;
  loading?: boolean;
  isDisabled?: boolean;
  opacityOnDisabled?: boolean;
  dataTestId?: string;
}

export const LoginButton: React.FC<LoginButtonProps> = ({
  callback,
  text = 'login',
  type = 'button',
  variant,
  iconClass,
  iconSrc,
  iconSize = '24px',
  children,
  backgroundColor,
  textColor,
  loading = false,
  isDisabled = false,
  opacityOnDisabled = true,
  dataTestId = '',
}: LoginButtonProps) => {
  return (
    <StyledLoginButton
      type={type}
      className={`loginButton ${variant || ''}`}
      onClick={() => !isDisabled && callback?.()}
      backgroundColor={backgroundColor}
      textColor={textColor}
      disabled={isDisabled}
      data-testid={dataTestId}
      iconSize={iconSize}
      opacityOnDisabled={opacityOnDisabled}
    >
      {loading ? (
        <CircularProgress sx={{ color: 'white' }} size={18} />
      ) : (
        <>
          {iconClass && <i className={`prefix-icon ${iconClass}`} />}
          {iconSrc ? <img src={iconSrc} alt="icon" /> : null}
          <Stack
            direction="row"
            style={{
              color: textColor ? createGradientOrSolid(textColor) : '#00000',
            }}
            className="text-wrapper"
          >
            {children}
            <div>{text}</div>
          </Stack>
        </>
      )}
    </StyledLoginButton>
  );
};
